export default {"src":"/_next/static/media/icon-level-2.81ee3eaa.svg","height":25,"width":52};